import React, { Component } from "react";
import { Col, Row, Form, Button } from "react-bootstrap";
import Pagination from "../../Pagination/Pagination";
import classes from "./jobProfile.module.css";
import { connect } from "react-redux";
// import './chips.scss';
// import Select from 'react-select'
import search from "../../../Assets/icons/0.75x/searchldpi.png";
// import {connect} from 'react-redux';
// import * as actionTypes from '../../../Action/Index';
import Loader from "react-loader-advanced";
import * as actionTypes from "../../../Action/Index";
// import Spinner from 'react-bootstrap/Spinner';
import NoDataErrorScreen from "../../commonComponents/NoDataErrorScreen";
import ServerErrorScreen from "../../commonComponents/ServerErrorScreen";
import loading from "../../../Assets/Images/loader-green.gif";
// import SweetAlert from '../../commonComponents/SweetAlert';
import NewSweetAlert from "react-bootstrap-sweetalert";
import "../../commonComponents/SweetAlert.css";
import { withRouter } from "react-router";

import ModeofInterview from "./Modeofinterview";
import ViewProfile from "../../JobProfile/ViewJobProfile/ViewJobProfile";

class JobProfile extends Component {
  state = {
    currentPage: 1,
    searchItem: [],
    viewProfileModal: false,
    viewSingleData: {},
    error: "",
    noResults: false,
    sufficientBalance: false,
    companyName: null,
    selectedJobProfile: {
      id: null,
      jobtitle: null,
      clientName: null,
      minExp: null,
      maxExp: null,
    },
    joberror: "",
  };

  onPageChange = (id) => {
    this.setState(
      {
        currentPage: id,
      },
      () => {
        this.props.getScheduleProfileList(
          this.state.currentPage,
          this.state.searchItem
        );
      }
    );
    //this.props.jobProfilePageNumber(id);
  };
  onLeftChange = () => {
    if (this.state.currentPage === 1) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage - 1,
      },
      () => {
        this.props.getScheduleProfileList(
          this.state.currentPage,
          this.searchField.value.split(",")
        );
      }
    );
    //this.props.jobProfilePageNumber(this.state.currentPage-1);
  };
  onRightChange = () => {
    if (this.props.records === this.state.currentPage) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      () => {
        this.props.getScheduleProfileList(
          this.state.currentPage,
          this.searchField.value.split(",")
        );
      }
    );
    //this.props.jobProfilePageNumber(this.state.currentPage+1);
  };

  componentWillReceiveProps(nextProps) {
    // if(nextProps.sufficientBalance != true)
    // {
    //     this.props.history.push('/interview')
    // }
    this.setState({
      noResults: nextProps.searchNoResults,
    });
  }

  componentDidMount() {
    this.props.getScheduleProfileList(this.state.currentPage, []);
    this.setState({
      noResults: false,
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  // let searchFormData = event.target.search.value.split(",");
  // this.setState({
  //     searchItem: searchFormData,
  // })
  //    this.props.getScheduleProfileList(this.state.currentPage, searchFormData)

  // }

  searchHandler = () => {
    const newarr = this.searchField.value;
    const arr = newarr.split(",");
    this.props.searchScheduleJobProfile(arr, 1);
    this.setState({
      currentPage: 1,
    });
  };
  searchHandler2 = (e) => {
    e.preventDefault();
    if (e.keyCode == 13) {
      const newarr = this.searchField.value;
      const arr = newarr.split(",");
      this.props.searchScheduleJobProfile(arr, 1);
      this.setState({
        currentPage: 1,
      });
    }
  };

  viewJobProfileModal = (boolean) => {
    this.setState({
      viewProfileModal: boolean,
    });
  };

  check = (event) => {
    let x = document.getElementsByTagName("tr");
    let i;
    for (i = 0; i < x.length; i++) {
      x[i].style.boxShadow = "none";
    }

    event.target.parentNode.parentNode.parentNode.style.boxShadow = "none";
  };

  //  onRadioSelectJob=(event)=>{
  //     // console.log(JSON.parse(event.target.value))
  //      this.setState({
  //          checked:true,
  //          selectedJobProfile:JSON.parse(event.target.value),
  //      })
  //  }

  hideAlert = () => {
    this.setState({
      joberror: "",
    });
  };

  arr = [];

  skills = "";

  render() {
    let maxOptions = [];
    for (let i = Number(this.state.min) + 1; i <= 10; i++) {
      maxOptions.push({ value: i, label: `${i}` });
    }
    let monthsOptions = [];
    for (let i = 0; i <= 11; i++) {
      monthsOptions.push({ value: i, label: `${i}` });
    }

    return (
      <>
        <Row className={classes.gapTop}>
          <Col md={8}>
            <Form
              className="form-inline"
              onSubmit={(e) => this.handleSubmit(e)}
            >
              <Form.Group className="mx-sm-4">
                <Form.Control
                  ref={(element) => (this.searchField = element)}
                  onKeyUp={(e) => this.searchHandler2(e)}
                  type="text"
                  className={`${classes.inputText} shadow-none`}
                  maxLength="52"
                  name="search"
                  placeholder="Search by  Title or Skills"
                />
              </Form.Group>
              <Button
                onClick={() => this.searchHandler()}
                type="button"
                variant="warning"
                className={` ${classes.searchButton} ${classes.btnWarning} `}
              >
                {" "}
                <img
                  type="image/svg+xml"
                  src={search}
                  width="25px"
                  alt="search"
                />
              </Button>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.state.joberror !== "" ? (
              <NewSweetAlert
                style={{ width: "400px", marginLeft: "-210px" }}
                warning
                onConfirm={this.hideAlert}
                confirmBtnBsStyle="none"
                confirmBtnCssClass="confirmButtonStyle"
              >
                {this.state.joberror}
              </NewSweetAlert>
            ) : null}
            {/* <span className={classes.error}>&nbsp; {this.state.error}</span> */}
          </Col>

          <Col md={12}>
            <ModeofInterview
              show={this.props.selecttypeofInterview}
              openModeofinterview={this.props.openModeofinterview}
              selectModeofInterview={this.props.selectModeofInterview}
            />
          </Col>
        </Row>

        <Loader
          show={this.props.loader}
          message={<img src={loading} />}
          foregroundStyle={{ color: "#00a99d" }}
          backgroundStyle={{ backgroundColor: "#F3EFEF" }}
        >
          {!this.props.serverErrorStatus ? (
            this.props.scheduleInterviewJobProfileList.length !== 0 &&
            !this.props.scheduleInterviewJobProfileNodata ? (
              <>
                <Row>
                  <Col
                    md={12}
                    className="table-responsive"
                    style={{ height: "60vh", marginTop: "20px" }}
                  >
                    <table
                      className={classes.scheduleTbl}
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: "0px 0px",
                      }}
                    >
                      <thead>
                        <tr>
                          <th style={{ zIndex: 500 }}>&nbsp;</th>
                          <th>Title</th>
                          <th>Experience</th>
                          <th>Skills</th>
                          <th>Date of Posting</th>
                        </tr>
                      </thead>
                      <tbody id="jobprofile">
                        {this.props.scheduleInterviewJobProfileList.map(
                          (element) => {
                            const must =
                              element.allJobSkillsWithPreecedence.map(
                                (el, index) => {
                                  return index ==
                                    element.allJobSkillsWithPreecedence.length
                                    ? el.value
                                    : " " + el.value;
                                }
                              );

                            this.skills = must.join();

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];
                            let current_datetime = new Date(
                              element.created / 1000
                            );
                            let formatted_date =
                              current_datetime.getDate() +
                              " " +
                              months[current_datetime.getMonth()];
                            let obj = {
                              id: element.id,
                              jobtitle: element.jobTitle,
                              clientName: element.clientName,
                              minExp: element.minExperience,
                              maxExp: element.maxExperience,
                              skills: this.skills,
                            };
                            this.arr.push("0");

                            return (
                              <tr key={element.id}>
                                <td width="10%">
                                  <label className={classes.profile}>
                                    <input
                                      type="radio"
                                      required
                                      onClick={this.props.onRadioSelectJob}
                                      onChange={(e) => this.check(e)}
                                      value={JSON.stringify(obj)}
                                      name="jobProfile"
                                      checked={
                                        this.props.selectedJobProfile.id ==
                                        element.id
                                      }
                                    />
                                    <span className={classes.checkmark}></span>
                                  </label>
                                </td>
                                <td
                                  onClick={() => {
                                    this.viewJobProfileModal(true);
                                    this.setState({ viewSingleData: element });
                                  }}
                                  style={{
                                    maxWidth: "10vw",
                                    minWidth: "10vw",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    paddingRight: "20px",
                                  }}
                                >
                                  {element.jobTitle}
                                  {element.clientName != undefined &&
                                  element.clientName != null &&
                                  element.clientName != ""
                                    ? " (" + element.clientName + ")"
                                    : null}
                                </td>
                                <td
                                  onClick={() => {
                                    this.viewJobProfileModal(true);
                                    this.setState({ viewSingleData: element });
                                  }}
                                  width="15%"
                                >
                                  {element.minExperience}{" "}
                                  {element.minExperience > 1 ? "years" : "year"}{" "}
                                  {element.maxExperience}{" "}
                                  {element.maxExperience > 1
                                    ? "months"
                                    : "month"}
                                </td>
                                <td
                                  onClick={() => {
                                    this.viewJobProfileModal(true);
                                    this.setState({ viewSingleData: element });
                                  }}
                                  style={{
                                    maxWidth: "20vw",
                                    minWidth: "20vw",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                  }}
                                >
                                  {this.skills}
                                </td>
                                <td
                                  onClick={() => {
                                    this.viewJobProfileModal(true);
                                    this.setState({ viewSingleData: element });
                                  }}
                                  width="20%"
                                >
                                  {formatted_date}
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </Col>
                </Row>
                <div className={classes.footer}>
                  <Row>
                    <Col md={1}></Col>
                    <Col md={8} style={{ marginLeft: "80px" }}>
                      {this.props.records > 1 ? (
                        <Pagination
                          activePage={this.state.currentPage}
                          pageRangeDisplayed={this.props.records}
                          onPageChange={this.onPageChange}
                          onLeftChange={this.onLeftChange}
                          onRightChange={this.onRightChange}
                        />
                      ) : null}
                    </Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        variant="warning"
                        onClick={() => {
                          this.props.handleJobProfilePage(
                            "mode",
                            this.props.selectedJobProfile
                          );
                          this.props.clearAllFilter();
                          this.props.onRadioSelectInterviewer("candidate");
                          this.props.selectedJobProfile.id === null &&
                            this.setState({
                              joberror: "Please select a Job Profile",
                            });
                        }}
                        className={` ${classes.nextBtn} ${classes.btnWarning} `}
                      >
                        {" "}
                        Next{" "}
                      </Button>
                    </Col>
                  </Row>
                </div>
                <br />
                <ViewProfile
                  show={this.state.viewProfileModal}
                  hideJobProfileModal={() => this.viewJobProfileModal(false)}
                  id={this.state.id}
                  viewSingleData={this.state.viewSingleData}
                />
              </>
            ) : this.state.noResults ? (
              <NoDataErrorScreen msg="No results found" />
            ) : (
              <NoDataErrorScreen msg="No Job profile created yet" />
            )
          ) : (
            <ServerErrorScreen />
          )}
        </Loader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: state.employeeReducer.loader,
    checkBalanceLoader: state.employeeReducer.checkBalanceLoader,
    scheduleInterviewJobProfileList:
      state.employeeReducer.scheduleInterviewJobProfileList,
    records: state.employeeReducer.records,
    serverErrorStatus: state.employeeReducer.serverErrorStatus,
    scheduleInterviewJobProfileNodata:
      state.employeeReducer.scheduleInterviewJobProfileNodata,
    searchNoResults: state.employeeReducer.scheduleJobNoResults,
    sufficientBalance: state.employeeReducer.sufficientBalance,
    companyName: state.employeeReducer.companyName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getScheduleProfileList: (page, searchItem) =>
      dispatch(actionTypes.getScheduleProfileList(page, searchItem)),
    searchScheduleJobProfile: (arr, page) =>
      dispatch(actionTypes.searchScheduleJobProfile(arr, page)),
    clearAllFilter: () => dispatch(actionTypes.clearAllFilter()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(JobProfile)
);
